import React, { Component } from 'react'
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

export default class Footter extends Component {
    render() {
        return (
            <div>
        <footer className="footer--pin">
        <MDBFooter color="warning-color-dark" className="font-small pt-4 mt-4" >
          <MDBContainer fluid className="text-center text-md-right">
            <MDBRow>
              <MDBCol md="12">
                 {/* <p>
                 สำนักส่งเสริมวิชาการและงานทะเบียน มหาวิทยาลัยราชภัฏกำแพงเพชร
                </p> */}
                <h5 className="title text-center">Kamphaeng Phet Rajabhat University</h5>
               
              
              </MDBCol>
            
            </MDBRow>
          </MDBContainer>
          <div className="footer-copyright text-center py-3">
            <MDBContainer fluid>
              &copy; {new Date().getFullYear()} Copyright: <a href="https://www.kpru.ac.th/"> www.kpru.ac.th </a>
            </MDBContainer>
          </div>
        </MDBFooter>
        </footer>
            </div>
        )
    }
}
